import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    const verify = async () => {
      try {
        const res = await axios.post(`${API}/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage(res.data.message || 'Email verified successfully!');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Verification failed. The link may be expired.');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FBF4EA] flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="card max-w-md w-full text-center py-12">
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-[#8B2E3C] animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-bold text-[#222]">Verifying your email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-[#222] mb-2">Email Verified!</h2>
            <p className="text-[#666] mb-6">{message}</p>
            <Link to="/login" className="btn-primary inline-block" data-testid="go-to-login">
              Go to Login
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-[#222] mb-2">Verification Failed</h2>
            <p className="text-[#666] mb-6">{message}</p>
            <Link to="/login" className="btn-primary inline-block" data-testid="go-to-login">
              Go to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
